<template>
  <section>
    <div v-if="!shouldShowFileViewer(this.s3UploadCategory, this.prefix)">
      <UploadManagerS3
        :s3UploadCategory="this.s3UploadCategory"
        :prefix="this.prefix"
        @uploadSuccess="saveUploadToUser"
      />
    </div>
    <div v-if="shouldShowFileViewer(this.s3UploadCategory, this.prefix)">
      <FileViewer
        :s3UploadKey="getS3Key(this.s3UploadCategory, this.prefix)"
        :btnViewText="this.btnViewText"
      />
    </div>
  </section>

</template>

<script>
import UploadManagerS3 from '@/components/UploadManagerS3';
import FileViewer from '@/components/FileViewer';
import ValidationUtil from '@/utils/ValidationUtil';
import { S3_UPLOAD_CATEGORIES } from '@/utils/Enums';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    s3UploadCategory: {
      required: true,
      validator: (c) => {
        return _.keys(S3_UPLOAD_CATEGORIES)
          .indexOf(c) !== -1;
      },
    },
    btnViewText: {
      require: false,
      default: 'View File',
    },
    onlyShowFileUpload: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  components: {
    FileViewer,
    UploadManagerS3,
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    saveUploadToUser(uploadResult) {
      const { key, timestamp, s3UploadCategory } = uploadResult;

      const dbCategoryKey = S3_UPLOAD_CATEGORIES[s3UploadCategory].dbKey;

      if (S3_UPLOAD_CATEGORIES[s3UploadCategory].hasMany) {
        this.user.uploads[dbCategoryKey].push({
          key, // the file key
          dateUploaded: timestamp,
        });
      } else {
        this.user.uploads[dbCategoryKey] = {
          key,
          dateUploaded: timestamp,
        };
      }

      this.saveUser();
    },
    saveUser() {
      this.setIsLoading(true);
      this.axios
        .post(
          `https://p2p3e209fb.execute-api.us-east-1.amazonaws.com/dev/users/${
            this.user.userId
          }`,
          this.user,
        )
        .then((res) => {
          this.setIsLoading(false);
          this.$toast.open('Saved!');
        });
    },
    shouldShowFileViewer(category, prefix) {
      if (this.onlyShowFileUpload) {
        return false;
      }
      return ValidationUtil.shouldShowFileViewer(this.user, category, prefix);
    },
    getS3Key(category, prefix) {
      return ValidationUtil.getS3Key(this.user, category, prefix);
    },
  },
};
</script>

<style scoped>

</style>
